import { render, staticRenderFns } from "./EducationButton.vue?vue&type=template&id=62e46cd2&scoped=true&"
import script from "./EducationButton.vue?vue&type=script&lang=ts&"
export * from "./EducationButton.vue?vue&type=script&lang=ts&"
import style0 from "./EducationButton.vue?vue&type=style&index=0&id=62e46cd2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e46cd2",
  null
  
)

export default component.exports